import { useMutation } from "@tanstack/react-query";
import { apiV1 } from "api-v2";

import type { AuthenticateResponse } from "../types/AuthenticateResponse.type";

export interface TwoFactorChallengePayload {
	mfa_token: string;
	code?: string;
	recovery_code?: string;
	remember_device?: boolean;
}

/**
 * React Query mutation for `POST auth/two-factor-challenge` — verifies the
 * pending login's second factor (TOTP `code` OR single-use `recovery_code`) and,
 * on success, establishes the session (cookie) and returns the full
 * authenticated user. The `mfa_token` is held in component state only and never
 * persisted. `retry: false` so a wrong code / lockout is surfaced immediately
 * rather than silently re-submitted.
 */
export const useTwoFactorChallenge = () =>
	useMutation<AuthenticateResponse, unknown, TwoFactorChallengePayload>({
		mutationFn: async (payload) => {
			const res = await apiV1.post<AuthenticateResponse>(
				"auth/two-factor-challenge",
				payload
			);
			return res.data;
		},
		retry: false,
	});
